// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-c12f7c88]:export{primaryColor:#ffb81c;secondaryColor:#07a1c1;accentColor:#eb6200}", ""]);
// Exports
module.exports = exports;
